import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import moment from "moment";
import styles from "./ModalBloquearStyles";
import { periodos } from "./Constants";
import { InputDateForm } from "../../../components/Modal/Input";
import { ReactSelect, ReactSelectCheckbox } from "../../../components/Select/SelectSearch";
import PeriodDate from "../../../components/PeriodDate/PeriodDate";
import ModalConfirmacao from "../../../components/Modal/ModalConfirmacao/ModalConfirmacao";
import LockIcon from "../../../components/Icon/LockIcon";
import UnlockIcon from "../../../components/Icon/UnlockIcon";
import { generateTimeList } from '../../../utils/generateTimeList';
import { countChecked } from './util/utils';
import MultiToggleButtons from "../../../components/Button/MultiToggleButtons";
import { findAllPeriodoAtendimentoModificadoAuditId } from "../../../services/AuditoriaService";
import Auditoria from "./Auditoria/Auditoria";
import { findProfissionalSaudeByUnidadeComAgenda } from "../../../services/ProfissionalSaudeService";
import { getUnidadeLogado } from "../../../services/UsuarioService";
import MultiDatePicker from "../../../components/MultiDatePicker";
import { findConveniosByAtivo } from "../../../services/ConvenioService";


const iconProps = {
  size: 24,
  color: "#FFF",
};

const ModalBloquearAgenda = observer(({
  classes,
  open,
  close,
  handleOpenModalConfirmacao,
  atendimentoStore,
  auditoriaStore,
  operation,
  isLoading,
  profissionalSaudeId
}) => {
  const [periodo, setPeriodo] = useState("");
  const [tabSelected, setTabSelected] = useState(0)
  const [conveniosOptions, setConveniosOptions] = useState([]);
  const [conveniosSelecionados, setConveniosSelecionados] = useState([]);

  const handlePeriodo = (e) => {
    atendimentoStore.dataSelecionadaBloqueioAgenda = {
      dataInicial: null,
      dataFinal: null,
    }

    if (e.nome === "Personalizado") {
      atendimentoStore.dataSelecionadaBloqueioAgenda = !atendimentoStore
        .dataSelecionadaBloqueioAgenda?.dataInicial && {
        dataInicial: moment().format("YYYY-MM-DD"),
        dataFinal: moment().format("YYYY-MM-DD"),
      };
    }

    if (e.nome === "Semana") {
      atendimentoStore.dataSelecionadaBloqueioAgenda = {
        dataInicial: moment()
          .day(0)
          .format("YYYY-MM-DD"),
        dataFinal: moment()
          .day(6)
          .format("YYYY-MM-DD"),
      };
    }

    setPeriodo(e);
  };

  const handleDia = (e) => {
    atendimentoStore.dataSelecionadaBloqueioAgenda = {
      dataInicial: e,
      dataFinal: e,
    };
  };

  const handleChangeDate = (dataInicial, dataFinal) => {
    atendimentoStore.dataSelecionadaBloqueioAgenda = {
      dataInicial,
      dataFinal,
    };
  };

  const confirmaBloqueioAgenda = () => {
    atendimentoStore.conveniosBloqueioAgenda = conveniosSelecionados;
    handleOpenModalConfirmacao();
  };

  const handleMes = (datas) => {
    atendimentoStore.dataSelecionadaBloqueioAgenda.datas = datas
  };

  const handledataSelecionadaBloqueioAgenda = (value) => {
    atendimentoStore.dataSelecionadaBloqueioAgenda = value;
  };
  const getProfissionaisOptions = async () => {
    try {
      let pageableDTO = {
        sortDir: 'ASC',
        sortField: 'nome',
        pageNumber: 0,
        pageSize: 999,
      };
      const unidade = await getUnidadeLogado()
      if (!unidade?.id) {
        return
      }
      const response = await findProfissionalSaudeByUnidadeComAgenda({
        search: null,
        unidadeId: unidade?.id || null,
        pageableDTO
      });

      const profissionaisSaudeByUnidadeComAgenda = response?.data?.data?.findProfissionalSaudeByUnidadeComAgenda
      if (profissionaisSaudeByUnidadeComAgenda) {
        const profissionaisSaudeByUnidadeOptions = [{
          value: "Todos os profissionais",
          label: "Todos os profissionais",
          checked: false
        }]

        profissionaisSaudeByUnidadeComAgenda.forEach((item) =>
          profissionaisSaudeByUnidadeOptions.push({
            value: item.id,
            label: item.nome,
            checked: profissionalSaudeId === item.id
          }))
        atendimentoStore.profissionaisAgendaBloqueadaOptions = profissionaisSaudeByUnidadeOptions
      }
    } catch (error) {
      console.log(error)

    }
  }

  const loadConvenios = async () => {
    try {
      const unidade = await getUnidadeLogado();
      const response = await findConveniosByAtivo(unidade?.id);
      const convenios = response?.data?.data?.convenios || [];
      setConveniosOptions(convenios.map(c => ({ value: c.id, label: c.descricao })));
    } catch (e) {
      console.error(e);
    }
  };
  const getHorariosToCheck = () => {
    if(!atendimentoStore?.configVigente?.duracao || !atendimentoStore?.configVigente?.horaInicioPeriodoAtendimento || !atendimentoStore?.configVigente?.horaFimPeriodoAtendimento) {
      return atendimentoStore.showAlertMessage({ isOpen: true,message: "configuracao de horario de atendimento!",variant:  "error"})
    }

    const { duracao, horaInicioPeriodoAtendimento, horaFimPeriodoAtendimento } = atendimentoStore?.configVigente;
    const timeList = generateTimeList(horaInicioPeriodoAtendimento, horaFimPeriodoAtendimento, duracao);
    timeList.unshift('Dia todo');
    return timeList.map(time => ({ label: time, value: time, checked: false }));
  };

  const changeTabSelected = async (tabSelected) => {
    auditoriaStore.auditoriaProps = {
      ...auditoriaStore.auditoriaProps,
      auditoria: `o ${operation === "BLOQUEAR" ? "bloqueio" : "desbloqueio"}`,
      auditoriaTela: "PeriodoAtendimentoModificado",
      pageNumber: 0,
      lastPage: false,
      auditorias: [],
    };

    if (tabSelected === 1) {

      auditoriaStore.load = {
        query: findAllPeriodoAtendimentoModificadoAuditId,
        variableName: "id",
        variableId: profissionalSaudeId,

      }
      await auditoriaStore.loadAuditItems();
    }

    setTabSelected(tabSelected)
  }
  const checkDisabledSecundaryButton = () => {
    const { dataSelecionadaBloqueioAgenda, horariosOptions, profissionaisAgendaBloqueadaOptions } = atendimentoStore
    return (!dataSelecionadaBloqueioAgenda?.dataInicial && dataSelecionadaBloqueioAgenda?.datas?.length <= 0)
      || countChecked(horariosOptions) === 0
      || countChecked(profissionaisAgendaBloqueadaOptions) === 0
      || isLoading || !horariosOptions
  }
  const handleClickHorario = (horarios) => {
    const { horariosOptions } = atendimentoStore;
    let horariosOptionsAux = [...horariosOptions];
  
    const opcaoDiaTodoSelecionadoHorarios = horarios.some(item => item.value === "Dia todo");
    const opcaoDiaTodoSelecionadoHorariosOptions = horariosOptionsAux.some(item => item.value === "Dia todo" && item.checked);
  
    if (opcaoDiaTodoSelecionadoHorariosOptions) {
      horariosOptionsAux = opcaoDiaTodoSelecionadoHorarios
        ? horariosOptionsAux.map(h => ({ ...h, checked: h.value === "Dia todo" ? false : horarios.some(item => item.value === h.value) }))
        : horariosOptionsAux.map(h => ({ ...h, checked: false }));

    } else {
      horariosOptionsAux = (opcaoDiaTodoSelecionadoHorarios || (!opcaoDiaTodoSelecionadoHorarios && horarios.length === horariosOptionsAux.length - 1))
        ? horariosOptionsAux.map(h => ({ ...h, checked: true }))
        : horariosOptionsAux.map(h => ({ ...h, checked: horarios.some(item => item.value === h.value) }));
    }
  
    atendimentoStore.horariosOptions = horariosOptionsAux;
  };

  const handleClickProfissionais = (profissionais) => {

    const { profissionaisAgendaBloqueadaOptions } = atendimentoStore;
    let profissionaisAgendaBloqueadaOptionsAux = profissionaisAgendaBloqueadaOptions;
    const allProfissionais = profissionais.some(item => item.value === "Todos os profissionais");
    const allProfissionaisChecked = profissionaisAgendaBloqueadaOptionsAux.some(item => item.value === "Todos os profissionais" && item.checked);
    const conditionAllCheckedTrue = allProfissionais || (!allProfissionais && profissionais.length === profissionaisAgendaBloqueadaOptionsAux.length - 1)

    if (allProfissionaisChecked) {
      profissionaisAgendaBloqueadaOptionsAux = allProfissionais
        ? profissionaisAgendaBloqueadaOptionsAux.map(h => ({
          ...h, checked: h.value === "Todos os profissionais" ?
            false : profissionais.some(item => item.value === h.value)
        }))
        : profissionaisAgendaBloqueadaOptionsAux.map(h => ({ ...h, checked: false }));

    } else {
      profissionaisAgendaBloqueadaOptionsAux = conditionAllCheckedTrue
        ? profissionaisAgendaBloqueadaOptionsAux.map(h => ({ ...h, checked: true }))
        : profissionaisAgendaBloqueadaOptionsAux.map(h => ({ ...h, checked: profissionais.some(item => item.value === h.value) }));
    }

    atendimentoStore.profissionaisAgendaBloqueadaOptions = profissionaisAgendaBloqueadaOptionsAux;

  };


  const renderSelectDate = () => {
    switch (periodo?.nome) {
      case "Dia":
      default:
        return (
          <InputDateForm
            id="agd-mba-inp-dat"
            iconposition="end"
            className={classes.dateTime}
            disabled={!periodo?.nome}
            classes={{
              date: classes.inputDate,
            }}
            value={atendimentoStore.dataSelecionadaBloqueioAgenda.dataInicial}
            onChange={handleDia}
          />
        );
      case "Semana":
        return (
          <PeriodDate
            id="agd-mba-inp-sem"
            filter={atendimentoStore.dataSelecionadaBloqueioAgenda}
            setFilter={handledataSelecionadaBloqueioAgenda}
            onChangeDate={handleChangeDate}
            handleAplicar={() => {}}
            stylePopper={classes.popperPeriodDate}
            withoutZIndex
          />
        );
      case "Mês":
        return (
          <MultiDatePicker
            id="agd-mba-inp-mes"
            values={atendimentoStore?.dataSelecionadaBloqueioAgenda?.datas}
            onChange={handleMes}
          />
        );
      case "Personalizado":
        return (
          <PeriodDate
            id="agd-mba-inp-prs"
            filter={atendimentoStore.dataSelecionadaBloqueioAgenda}
            setFilter={handledataSelecionadaBloqueioAgenda}
            onChangeDate={handleChangeDate}
            handleAplicar={() => {}}
            stylePopper={classes.popperPeriodDate}
            withoutZIndex
          />
        );
    }
  };

  useEffect(() => {
    atendimentoStore.horariosOptions = getHorariosToCheck();
    getProfissionaisOptions()
    if (operation !== "BLOQUEAR") {
      loadConvenios();
    }
  }, []);

  const getLabelPeriodo = () => {
    const acao = operation === "BLOQUEAR" ? "bloquear" : "desbloquear";
    return `Qual período você deseja ${acao}?`
  };

  return (
    <ModalConfirmacao
      open={open}
      icon={operation === "BLOQUEAR" ? <LockIcon {...iconProps} /> : <UnlockIcon {...iconProps} />}
      color={"gray"}
      title={operation === "BLOQUEAR" ? "Bloquear Agenda" : "Desbloquear Agenda"}
      classes={{
        paperAlert: classes.paperAlert,
      }}
      buttons={{
        labelPrimaryButton: "Cancelar",
        handlePrimaryButton: () => close(),
        disabledPrimaryButton: isLoading,
        loadingPrimaryButton: isLoading,
        idPrimaryButton: "agd-mba-btn-cnc",
        labelSecondButton: "Continuar",
        handleSecondButton: () => confirmaBloqueioAgenda(),
        disabledSecondButton: checkDisabledSecundaryButton(),
        loadingSecondButton: isLoading,
        idSecondButton: "agd-mba-btn-ctn",
      }}
    >
      <div className={classes.content}>
        <MultiToggleButtons
          id="agd-mba-btn-tab"
          options={[operation === "BLOQUEAR" ? " Bloquear " : "Desbloquear ", "Auditoria"]}
          tabSelected={tabSelected}
          changeTabSelected={changeTabSelected}
          classes={{ buttonsContainer: classes.buttonsTabAuditoria }}
        />
        {tabSelected === 0 ?
          <>
        <div className={classes.inputWithLabelContainer}>

              <div className={classes.title}>{getLabelPeriodo()}</div>
          <ReactSelect
            id="agd-mba-sel-per"
            className={classes.selectSearch}
            placeholder="Selecione"
            value={periodo}
            options={periodos}
            getOptionLabel={(option) => option.nome}
            getOptionValue={(option) => option.value}
            onChange={handlePeriodo}
          />
        </div>

            <div className={classes.inputWithLabelContainer}>
              <div className={classes.title}> Profissionais </div>
              <ReactSelectCheckbox
                id="agd-mba-sel-prf"
                onChange={handleClickProfissionais}
                options={atendimentoStore.profissionaisAgendaBloqueadaOptions || []}
                value={atendimentoStore.profissionaisAgendaBloqueadaOptions.filter(item => item.checked)}

              />
            </div>

        <div className={classes.inputWithLabelContainer}>
          <div className={classes.title}> Selecione a data </div>
          {renderSelectDate()}
        </div>
        <div className={classes.inputWithLabelContainer}>
          <div className={classes.title}> Horário </div>
          <ReactSelectCheckbox
            id="agd-mba-sel-hor"
            onChange={handleClickHorario}
            options={atendimentoStore.horariosOptions || []}
            value={atendimentoStore?.horariosOptions?.filter(item => item.checked)}
            maxMenuHeight={130}
              />
            </div>
            {operation !== "BLOQUEAR" && (
              <div className={classes.inputWithLabelContainer}>
                <div className={classes.title}> Convênios </div>
                <ReactSelect
                  id="agd-mba-sel-cnv"
                  options={conveniosOptions}
                  value={conveniosSelecionados}
                  onChange={(options) => setConveniosSelecionados(options || [])}
                  isMulti
                  isClearable
                  placeholder="Todos os convênios"
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                />
              </div>
            )}
          </>
          :
          <div style={{ height: "183px" }}>
            <Auditoria
          />
        </div>
        }
      </div>
    </ModalConfirmacao>
  );
});

const ModalBloquearAgendaWithStyles = withStyles(styles)(ModalBloquearAgenda);
export default inject("atendimentoStore", "auditoriaStore")(ModalBloquearAgendaWithStyles);
